import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SearchResults from './SearchResults';
import MapSearchResult from './MapSearchResult';

export const MapSearchResults = ({ ...props }) => {
  if (props.results.length) {
    return (
      <SearchResults
        {...props}
        ResultComponent={MapSearchResult}
      />
    );
  }

  return false;
};

MapSearchResults.propTypes = {
  results: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  results: state.search.services.mapSearch.results,
});

export default connect(mapStateToProps)(MapSearchResults);
